module.exports = __webpack_public_path__ + "static/media/ShamanicFemaleFigures.574d26ae.png";